import { Col, Row, Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ListGroup from "../component/ListGroup";
import Banner from "../component/Banner";
import TableComp from "../component/Table";
import { useCallback, useEffect, useState } from "react";
import { HiPhone } from "react-icons/hi2";
import { TbLocationFilled } from "react-icons/tb";
import LinkDriverList from "../component/LinkDriverList";
import { MdEmail } from "react-icons/md";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import SessionUtil from "../util/SessionUtil";
import ApiUtil from "../util/ApiUtil";
import ApiPath from "../util/ApiPath";
import Pagination from "react-responsive-pagination";
import ReactLoading from "react-loading";
import "react-responsive-pagination/themes/classic.css";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css"; // مهم جداً
const CustomRow = ({ rowData, columnNames, handleTracking }) => {
  const lang = SessionUtil.getLang();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <tr>
      {columnNames.map((columnName, index) => (
        <td key={index}>
          {columnName === "DriverId" ? (
            <span>#{rowData.Id}</span>
          ) : columnName === "DriverName" ? (
            <div className="flex-gap-2">
              {rowData?.DriverImage ? (
                <div className="dimension-40 h-100">
                  <Image
                    alt="image"
                    src={rowData.DriverImage}
                    className="img-fluid rounded-1 cursor-pointer"
                    onClick={() => setIsOpen(true)}
                  />
                  {isOpen && (
                    <Lightbox
                      mainSrc={rowData.DriverImage}
                      onCloseRequest={() => setIsOpen(false)}
                    />
                  )}
                </div>
              ) : (
                <span className="img-empty"></span>
              )}
              <p className="mb-0">
                {lang === "en" || rowData.DriverNameAr === ""
                  ? rowData?.DriverNameEn
                  : rowData?.DriverNameAr}
              </p>
            </div>
          ) : columnName === "DriverPhone" ? (
            <div className="flex-gap-2">
              <HiPhone size={16} color={"#3A974C"} />{" "}
              <p className="mb-0">
                {"+" + rowData.AreaCode + "" + rowData.PhoneNumber}
              </p>
            </div>
          ) : columnName === "Email" ? (
            <div className="flex-gap-2">
              <MdEmail size={16} color="#4285F4" />
              <p className="mb-0" title={rowData.Email}>
                {rowData.Email}
              </p>
            </div>
          ) : columnName === "Status" ? (
            rowData.Status === "ONLINE" ? (
              <div className="status status-success">{t("Online")}</div>
            ) : rowData.Status === "OFFLINE" ? (
              <div className="status status-failed">{t("Offline")}</div>
            ) : (
              <div className="status status-warning text-capitalize">
                {t(`${rowData.Status}`)}
              </div>
            )
          ) : (
            <p className="mb-0">{rowData[columnName]}</p>
          )}
        </td>
      ))}
      <td className="separate-column cursor-pointer">
        <div onClick={() => handleTracking(rowData)} className={`flex-gap-2  ${!rowData.IsOnline && "opacity-50"}`}>
          <TbLocationFilled size={16} color="#F2953C" />
          {t("Track")}
        </div>
      </td>
    </tr>
  );
};

const Operation = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const columnNames = [
    "DriverId",
    "DriverName",
    "DriverPhone",
    "Email",
    "Status",
  ];

  const [sortedData, setSortedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordCount, setRecordCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const isLoggedIn = SessionUtil.isLoggedIn(); // Custom hook or context

  const handleTracking = (data) => {
    if (data.Status !== "OFFLINE" && data.IsOnline) {
      navigate(`/tracking-driver/${data.Id}`, {
        state: {
          id: data.Id,
          page: "operation",
        },
      });
    }
  };
  const getDriverApi = useCallback(async () => {
    setLoading(true);
    let params = {
      PageNumber: currentPage,
      PageSize: "10",
      OrderBy: "Id Desc",
    };
    const res = await ApiUtil.postApi(
      ApiPath.GET_ALL_DRIVERS_FOR_OPERATION,
      params,
      "POST"
    );
    if (res.IsSuccessfull) {
      const totalPage = Math.ceil(res.Result.RecordCount / 10);
      setSortedData(res.Result.Driver);
      setRecordCount(totalPage);
      setLoading(false);
    }
  }, [currentPage]);

  useEffect(() => {
    if (isLoggedIn) {
      getDriverApi();
    }
  }, [isLoggedIn, getDriverApi]);
  const handlePageNumber = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <Row className="g-0">
      {!loading ? (
        <>
          <Col lg={8} className="position-relative">
            <ListGroup />
            <Banner />
            <div className=" mt-4 d-flex justify-content-between gap-2">
              <p className="title">{t("Driver List")}</p>
            </div>
            <TableComp
              data={sortedData}
              columnNames={columnNames}
              setSortedData={setSortedData}
              track={true}
            >
              {sortedData.map((rowData, index) => (
                <CustomRow
                  key={index}
                  rowData={rowData}
                  columnNames={columnNames}
                  handleTracking={handleTracking}
                />
              ))}
            </TableComp>
            <Pagination
              current={currentPage}
              total={recordCount}
              onPageChange={(pageNumber) => handlePageNumber(pageNumber)}
              extraClassName="justify-content-end"
            />
          </Col>

          <Col md={1}>
            <div className="divider-vertical mx-auto"></div>
          </Col>
          <Col lg={3} className="mt-5">
            <LinkDriverList
              title={t("Top Driver")}
              subtitle={t("Keep up to be TOP")}
              data={[]}
              page="driver"
            />
          </Col>
        </>
      ) : (
        <Col lg={12} className="loading-style">
          <ReactLoading
            type={"bars"}
            color={"#c8c8c8"}
            height={"50px"}
            width={"50px"}
          />
        </Col>
      )}
    </Row>
  );
};

export default Operation;
